var map = {
	"./": "8b74",
	"./getArchivedTicketDetails": "64c4",
	"./getArchivedTicketDetails.js": "64c4",
	"./getArchivedTickets": "93e1",
	"./getArchivedTickets.js": "93e1",
	"./getPendingTickets": "bedf",
	"./getPendingTickets.js": "bedf",
	"./getTicketById": "7381",
	"./getTicketById.js": "7381",
	"./getTickets": "6d6e",
	"./getTickets.js": "6d6e",
	"./getTicketsOfPartner": "89ba",
	"./getTicketsOfPartner.js": "89ba",
	"./index": "8b74",
	"./index.js": "8b74",
	"./patchTicketData": "e81e",
	"./patchTicketData.js": "e81e",
	"./refreshTickets": "727e",
	"./refreshTickets.js": "727e",
	"./saveTicketData": "1530",
	"./saveTicketData.js": "1530"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b8ba";